import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { openPopup} from "../../store/popupSlice"
import Breadcrumb from "../../component/Breadcrumb";

const breadcrumbData = {
  newClass:"center-breadcrumb",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"Pricing",
      slug:"/pricing"
    }
  ]
}
export default function PriceHead() {
  const dispatch=useDispatch();
  return (
    <>
      <section className="price-head-area header-gap">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 text-center">
              <div className="price-head-content">
                <label >Tell Us </label>
                <h1 className="heading"><span className='gradiant-color'>About Your Business</span></h1>
                <span className='sub-heading'>and we shall respond promptly with precise launch pricing tailored to your needs.</span>
                <p>We seek dynamic and forward-thinking businesses poised for growth, eager to establish themselves as leaders in their respective regions. Our focus is on cultivating enduring partnerships, and we are fully prepared to invest in your success.</p>
                <small>21 Days Free Trial | No Credit Card Required</small>
                <Breadcrumb breadcrumbData={breadcrumbData}/>
                <Link onClick={() => dispatch(openPopup())} className='default-btn animated-btn'>contact us</Link>
                <img loading="lazy" className='price-head-content-vec img-responsive' src="assets/home/price-contact-vector.webp" alt="vector" />
              </div>

              <div className="price-head-img">
                <img className="img-responsive" src="assets/home/price-head-circle.webp" alt="circle" />
              </div>
            </div>
          </div>
        </div>

        <img loading="lazy" className='price-head-vec1 img-responsive' src="assets/home/pricing-head-vector.webp" alt="circle" />
        <img loading="lazy" className='price-head-vec2 img-responsive' src="assets/home/pricing-head-vector-1.webp" alt="circle" />
      </section>
    </>
  )
}
